<template>
  <div class="submit-suggestion">
    <a-drawer
      title="选择节点人"
      placement="bottom"
      height="100vh"
      :closable="false"
      :visible="visible"
      @close="toggleVisible"
      class="my-drawer-wrap"
    >
      <div class="drawer-body">
        <a-spin :spinning="$store.state.loading" tip="拼命加载中...">
          <a-tree
            v-if="approvalUsersTree"
            checkable
            :tree-data="approvalUsersTree[0].userList"
            :default-expanded-keys="['org$0_000000']"
            :replace-fields="replaceFields"
            @select="onSelect"
            @check="onCheck"
          />
          <div v-else class="no-tree"></div>
        </a-spin>
        <div class="btns">
          <a-button @click.native="cancelClick" style="padding:0 30px">
            取消
          </a-button>
          <a-button
            type="primary"
            @click.native="ensureClick"
            style="padding:0 30px"
          >
            确定
          </a-button>
        </div>
      </div>
    </a-drawer>
  </div>
</template>
<script>
export default {
  name: 'SelectApprovalUser',
  props: {
    approvalUsersTree: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      visible: false,
      replaceFields: {
        title: 'name',
        key: 'id'
      },
      // checkedIds: [],
      // leafIds: [],
      checkedItems: [],
      leafItems: []
    }
  },
  methods: {
    openDrawer() {
      this.visible = true
    },
    resetData() {
      this.checkedItems = []
      this.leafItems = []
    },
    toggleVisible() {
      this.visible = !this.visible
    },
    ensureClick() {
      // 拿出所有叶节点id
      // const leafIds = []
      // const len = this.checkedIds.length
      // for (let i = 0; i < len; i++)  {
      //   const itemArr = this.checkedIds[i].split('$')
      //   // 说明是叶节点
      //   itemArr.length > 2 && leafIds.push(itemArr.slice(-1)[0])
      // }
      // this.leafIds = leafIds
      // console.log(leafIds)
      // 拿出所有叶节点
      const leafItems = []
      const len = this.checkedItems.length
      // 检查必填项
      if (len === 0) {
        this.$message.warning({
          content: '请选择节点人'
        })
        return
      }
      // 格式化选中数据
      for (let i = 0; i < len; i++) {
        const item = this.checkedItems[i]
        const itemIdArr = item.id.split('$')
        // 说明是叶节点
        if (itemIdArr.length > 2) {
          leafItems.push({ code: itemIdArr.slice(-1)[0], name: item.name })
        }
      }
      this.leafItems = leafItems
      console.log(leafItems)
      this.$emit('onEnsure', leafItems)
      this.toggleVisible()
    },
    cancelClick() {
      this.toggleVisible()
    },
    onSelect() {
      console.log('onSelect')
    },
    onCheck(checkedKeys, e) {
      // 存储当前勾选的选项id
      // this.checkedIds = checkedKeys
      this.checkedItems = e.checkedNodes.map(item => {
        let { id, name } = item.data.props
        return { id, name }
      })
      // console.log(checkedKeys)
      console.log(this.checkedItems)
      console.log(e)
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../style/var';
.no-tree {
  width: 100%;
  height: 100%;
}
// .submit-suggestion {
//   margin-bottom: 7rem;
//   /deep/ .ant-drawer-wrapper-body {
//     position: relative;
//   }
// }
.my-drawer-wrap {
  /deep/ .ant-drawer-body {
    padding: 14px 20px;
  }
}
.drawer-body {
  padding-bottom: 60px;
}
.btns {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 20px 30px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #f2f2f2;
}
</style>
